export default __webpack_public_path__ + "static/media/check-thin.cbf515eb.svg";